import React, { useMemo, FC } from 'react';
import type { PresetSection } from '@wix/add-panel-common';
import type { ElementsRegistryDevProps } from './ElementsRegistryDev.types';
import { useUtils } from '../../../../../../UtilsProvider';
import { SectionViewInner } from '../../../../SectionView';

export const ElementsRegistryDev: FC<ElementsRegistryDevProps> = () => {
  const { getRegistrySections } = useUtils();
  const registrySectionsMap = getRegistrySections();

  const registrySections = useMemo<PresetSection[] | null>(
    () => (registrySectionsMap ? Array.from(registrySectionsMap.values()) : null),
    [registrySectionsMap],
  );

  if (!registrySections) {
    return <div>No sections found</div>;
  }

  return (
    <React.Fragment>
      {registrySections.map((registrySection, index) => (
        <SectionViewInner key={registrySection.automationId} section={registrySection} index={index} />
      ))}
    </React.Fragment>
  );
};
